import { Lock } from "lucide-react";

export function PermissionDeniedScreen() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="max-w-md text-center">
        <Lock size={32} className="mx-auto text-ink-4" aria-hidden />
        <h1 className="mt-4 text-lg font-medium text-ink-1">You don't have access to this page.</h1>
        <p className="mt-2 text-sm text-ink-3">
          Ask your entity admin or Flow global admin to grant the role you need.
        </p>
      </div>
    </div>
  );
}
